import moment from "moment";

export const validFutureDate = (date) => {
  if (date) {
    let d1 = moment(new Date(date))
      .locale("en")
      .utcOffset(0)
      .set("hour", 0)
      .set("minute", 0)
      .set("seconds", 0);
    let d2 = moment()
      .locale("en")
      .utcOffset(0)
      .set("hour", 0)
      .set("minute", 0)
      .set("seconds", 0);

    let diff1 = d1.diff(d2, "days");
    return diff1 >= 0;
  } else return true;
};

export const extcheck = (file, ext) => {
  if (file) {
    const file_ext = file.name.split(".").pop();
    return ext.includes(file_ext);
  } else return false;
};

export const sizecheck = (file, size) => {
  if (file) {
    return file.size / 1024 < size;
  } else return false;
};

export const dimensionsCheck = async (file, width, height) => {
  if (file) {
    const res = await new Promise((resolve) => {
      let img;
      img = new Image();
      let objectUrl = URL.createObjectURL(file);
      img.onload = function () {
        resolve([this.width, this.height]);
        URL.revokeObjectURL(objectUrl);
      };
      img.src = objectUrl;
    });
    return res[0] <= width && res[1] <= height;
  } else return false;
};

export const byteConverter = (bytes, decimals) => {
  const K_UNIT = 1024;
  const SIZES = ["Bytes", "KB", "MB", "GB", "TB", "PB"];

  if (bytes == 0) return "0 Byte";

  let i = Math.floor(Math.log(bytes) / Math.log(K_UNIT));
  let resp =
    parseFloat((bytes / Math.pow(K_UNIT, i)).toFixed(decimals)) +
    " " +
    SIZES[i];

  return resp;
};

export const color_enums = [
  { value: null, text: "select-an-option" },
  {
    value: "white",
    text: "white",
  },
  {
    value: "yellow",
    text: "yellow",
  },
  {
    value: "blue",
    text: "blue",
  },
  {
    value: "red",
    text: "red",
  },
  {
    value: "green",
    text: "green",
  },
  {
    value: "black",
    text: "black",
  },
  {
    value: "brown",
    text: "brown",
  },
  {
    value: "azure",
    text: "azure",
  },
  {
    value: "ivory",
    text: "ivory",
  },
  {
    value: "teal",
    text: "teal",
  },
  {
    value: "silver",
    text: "silver",
  },
  {
    value: "purple",
    text: "purple",
  },
  {
    value: "navy_blue",
    text: "navy-blue",
  },
  {
    value: "pea_green",
    text: "pea-green",
  },
  {
    value: "gray",
    text: "gray",
  },
  {
    value: "orange",
    text: "orange",
  },
  {
    value: "maroon",
    text: "maroon",
  },
  {
    value: "charcoal",
    text: "charcoal",
  },
  {
    value: "aquamarine",
    text: "aquamarine",
  },
  {
    value: "coral",
    text: "coral",
  },
  {
    value: "fuchsia",
    text: "fuchsia",
  },
  {
    value: "wheat",
    text: "wheat",
  },
  {
    value: "lime",
    text: "lime",
  },
  {
    value: "crimson",
    text: "crimson",
  },
  {
    value: "khaki",
    text: "khaki",
  },
  {
    value: "hot_pink",
    text: "hot-pink",
  },
  {
    value: "magenta",
    text: "magenta",
  },
  {
    value: "olden",
    text: "olden",
  },
  {
    value: "plum",
    text: "plum",
  },
  {
    value: "olive",
    text: "olive",
  },
  {
    value: "cyan",
    text: "cyan",
  },
  {
    value: "gold",
    text: "gold",
  },
  {
    value: "dark-orange",
    text: "dark-orange",
  },
  {
    value: "beige",
    text: "beige",
  },
  {
    value: "light-beige",
    text: "light-beige",
  },
];

export const damage_area_enums = [
  { value: null, text: "Select Area" },
  {
    value: "Side Mirror",
    text: "Side Mirror",
  },
  {
    value: "Rear View Mirror",
    text: "Rear View Mirror",
  },
  {
    value: "Right Light",
    text: "Right Light",
  },
  {
    value: "Left Light",
    text: "Left Light",
  },
  {
    value: "Highlight",
    text: "Highlight",
  },
  {
    value: "Seats",
    text: "Seats",
  },
  {
    value: "Car Interior",
    text: "Car Interior",
  },
  {
    value: "Number Plate",
    text: "Number Plate",
  },
  {
    value: "Arm Rests",
    text: "Arm Rests",
  },
  {
    value: "Sunroof",
    text: "Sunroof",
  },
  {
    value: "Key Control",
    text: "Key Control",
  },
  {
    value: "Key Locks",
    text: "Key Locks",
  },
  {
    value: "Seat Control",
    text: "Seat Control",
  },
  {
    value: "Window Control",
    text: "Window Control",
  },
  {
    value: "Hazard Control",
    text: "Hazard Control",
  },
  {
    value: "Hazard Signal",
    text: "Hazard Signal",
  },
  {
    value: "Electronic Screen",
    text: "Electronic Screen",
  },
  {
    value: "Radio",
    text: "Radio",
  },
  {
    value: "Air Condition",
    text: "Air Condition",
  },
  {
    value: "Indicator Control",
    text: "Indicator Control",
  },
  {
    value: "Front Head Lights",
    text: "Front Head Lights",
  },
  {
    value: "Rear Stop Lights",
    text: "Rear Stop Lights",
  },
  {
    value: "Wiper",
    text: "Wiper",
  },
  {
    value: "Glove compartment",
    text: "Glove compartment",
  },
];

export const body_damage_area_enums = [
  { text: "Left Side Front tire", value: "Left Side Front Tire" },
  { text: "Left Side Back tire", value: "Left Side Back Tire" },
  { text: "Left Side Front fender", value: "Left Side Front Fender" },
  { text: "Left Side Back fender", value: "Left Side Back Fender" },
  { text: "Left Side Front door", value: "Left Side Front Door" },
  { text: "Left Side Back door", value: "Left Side Back Door" },
  { text: "Right Side Front tire", value: "Right Side Front Tire" },
  { text: "Right Side Back tire", value: "Right Side Back Tire" },
  { text: "Right Side Front fender", value: "Right Side Front Fender" },
  { text: "Right Side Back fender", value: "Right Side Back Fender" },
  { text: "Right Side Front door", value: "Right Side Front Door" },
  { text: "Right Side Back door", value: "Right Side Back Door" },
  { text: "Front Front windshield", value: "Front Windshield" },
  { text: "Front Hood", value: "Front Hood" },
  { text: "Front Front bumper", value: "Front Bumper" },
  { text: "Back Back windshield", value: "Back Windshield" },
  { text: "Back Boot", value: "Back Boot" },
  { text: "Back Rear bumper", value: "Back Bumper" },
];

export const clientType_enums = [
  { text: "select-an-option", value: null },
  { text: "government", value: "Government" },
  { text: "international-agent", value: "International Agent" },
  { text: "local-agent", value: "Local Agent" },
  { text: "private", value: "Private" },
  { text: "individual", value: "Individual" },
  { text: "umrah-hajj", value: "Umrah / Hajj" },
  { text: "umra-customer", value: "Umra Customer" },
  { text: "tours-company", value: "Tours Company" },
];

export const contractType_enums = [
  { value: null, text: "select-an-option" },
  { text: "Permenant", value: "Permenant" },
  { text: "Temporary", value: "Temporary" },
  { text: "Acting", value: "Acting" },
  { text: "Seasonal", value: "Seasonal" },
];

export const countries = {
  Andorra: "أندورا",
  "United Arab Emirates": "الإمارات العربية المتحدة",
  Afghanistan: "أفغانستان",
  "Antigua and Barbuda": "أنتيغوا وبربودا",
  Anguilla: "أنغيلا",
  Albania: "ألبانيا",
  Armenia: "أرمينيا",
  Angola: "أنغولا",
  Antarctica: "القارة القطبية الجنوبية",
  Argentina: "الأرجنتين",
  "American Samoa": "ساموا الأمريكية",
  Austria: "النمسا",
  Australia: "أستراليا",
  Aruba: "أروبا",
  Åland: "أولاند",
  Azerbaijan: "أذربيجان",
  "Bosnia and Herzegovina": "البوسنة والهرسك",
  Barbados: "بربادوس",
  Bangladesh: "بنغلاديش",
  Belgium: "بلجيكا",
  "Burkina Faso": "بوركينا فاسو",
  Bulgaria: "بلغاريا",
  Bahrain: "البحرين",
  Burundi: "بوروندي",
  Benin: "بنين",
  "Saint Barthélemy": "سانت بارتيليمي",
  Bermuda: "برمودا",
  Brunei: "بروناي",
  Bolivia: "بوليفيا",
  Bonaire: "بونير",
  Brazil: "البرازيل",
  Bahamas: "جزر البهاما",
  Bhutan: "بوتان",
  "Bouvet Island": "جزيرة بوفيه",
  Botswana: "بوتسوانا",
  Belarus: "بيلاروسيا",
  Belize: "بليز",
  Canada: "كندا",
  "Cocos [Keeling] Islands": "جزر كوكوس",
  "Democratic Republic of the Congo": "جمهورية الكونغو الديموقراطية",
  "Central African Republic": "جمهورية افريقيا الوسطى",
  "Republic of the Congo": "جمهورية الكونغو",
  Switzerland: "سويسرا",
  "Ivory Coast": "ساحل العاج",
  "Cook Islands": "جزر كوك",
  Chile: "شيلي",
  Cameroon: "الكاميرون",
  China: "الصين",
  Colombia: "كولومبيا",
  "Costa Rica": "كوستا ريكا",
  Cuba: "كوبا",
  "Cape Verde": "كابو فيردي",
  Curacao: "كوراكاو",
  "Christmas Island": "جزيرة كريسماس",
  Cyprus: "قبرص",
  "Czech Republic": "الجمهورية التشيكية",
  Germany: "ألمانيا",
  Djibouti: "جيبوتي",
  Denmark: "الدنمارك",
  Dominica: "دومينيكا",
  "Dominican Republic": "جمهورية الدومينيكان",
  Algeria: "الجزائر",
  Ecuador: "الاكوادور",
  Estonia: "إستونيا",
  Egypt: "مصر",
  "Western Sahara": "الصحراء الغربية",
  Eritrea: "إريتريا",
  Spain: "إسبانيا",
  Ethiopia: "أثيوبيا",
  Finland: "فنلندا",
  Fiji: "فيجي",
  "Falkland Islands": "جزر فوكلاند",
  Micronesia: "ميكرونيزيا",
  "Faroe Islands": "جزر فاروس",
  France: "فرنسا",
  Gabon: "الجابون",
  "United Kingdom": "المملكة المتحدة",
  Grenada: "غرينادا",
  Georgia: "جورجيا",
  "French Guiana": "غيانا الفرنسية",
  Guernsey: "غيرنسي",
  Ghana: "غانا",
  Gibraltar: "جبل طارق",
  Greenland: "جرينلاند",
  Gambia: "غامبيا",
  Guinea: "غينيا",
  Guadeloupe: "جوادلوب",
  "Equatorial Guinea": "غينيا الإستوائية",
  Greece: "اليونان",
  "South Georgia and the South Sandwich Islands":
    "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
  Guatemala: "غواتيمالا",
  Guam: "غوام",
  "Guinea-Bissau": "غينيا بيساو",
  Guyana: "غيانا",
  "Hong Kong": "هونج كونج",
  "Heard Island and McDonald Islands": "جزيرة القلب وجزر ماكدونالز",
  Honduras: "هندوراس",
  Croatia: "كرواتيا",
  Haiti: "هايتي",
  Hungary: "هنغاريا",
  Indonesia: "إندونيسيا",
  Ireland: "أيرلندا",
  "Isle of Man": "جزيرة مان",
  India: "الهند",
  "British Indian Ocean Territory": "إقليم المحيط البريطاني الهندي",
  Iraq: "العراق",
  Iran: "إيران",
  Iceland: "أيسلندا",
  Italy: "إيطاليا",
  Jersey: "جيرسي",
  Jamaica: "جامايكا",
  Jordan: "الأردن",
  Japan: "اليابان",
  Kenya: "كينيا",
  Kyrgyzstan: "قيرغيزستان",
  Cambodia: "كمبوديا",
  Kiribati: "كيريباتي",
  Comoros: "جزر القمر",
  "Saint Kitts and Nevis": "سانت كيتس ونيفيس",
  "North Korea": "كوريا الشمالية",
  "South Korea": "كوريا الجنوبية",
  Kuwait: "الكويت",
  "Cayman Islands": "جزر كايمان",
  Kazakhstan: "كازاخستان",
  Laos: "لاوس",
  Lebanon: "لبنان",
  "Saint Lucia": "سانت لوسيا",
  Liechtenstein: "ليختنشتاين",
  "Sri Lanka": "سيريلانكا",
  Liberia: "ليبيريا",
  Lesotho: "ليسوتو",
  Lithuania: "ليتوانيا",
  Luxembourg: "لوكسمبورغ",
  Latvia: "لاتفيا",
  Libya: "ليبيا",
  Morocco: "المغرب",
  Monaco: "موناكو",
  Moldova: "مولدوفا",
  Montenegro: "مونتينيغرو",
  "Saint Martin": "سانت مارتن",
  Madagascar: "مدغشقر",
  "Marshall Islands": "جزر مارشال",
  "North Macedonia": "مقدونيا الشمالية",
  Mali: "مالي",
  "Myanmar [Burma]": "ميانمار [بورما]",
  Mongolia: "منغوليا",
  Macao: "ماكاو",
  "Northern Mariana Islands": "جزر مريانا الشمالية",
  Martinique: "مارتينيك",
  Mauritania: "موريتانيا",
  Montserrat: "مونتسيرات",
  Malta: "مالطا",
  Mauritius: "موريشيوس",
  Maldives: "جزر المالديف",
  Malawi: "ملاوي",
  Mexico: "المكسيك",
  Malaysia: "ماليزيا",
  Mozambique: "موزمبيق",
  Namibia: "ناميبيا",
  "New Caledonia": "كاليدونيا الجديدة",
  Niger: "النيجر",
  "Norfolk Island": "جزيرة نورفولك",
  Nigeria: "نيجيريا",
  Nicaragua: "نيكاراغوا",
  Netherlands: "هولندا",
  Norway: "النرويج",
  Nepal: "نيبال",
  Nauru: "ناورو",
  Niue: "نيوي",
  "New Zealand": "نيوزيلندا",
  Oman: "سلطنة عمان",
  Panama: "بنما",
  Peru: "بيرو",
  "French Polynesia": "بولينيزيا الفرنسية",
  "Papua New Guinea": "بابوا غينيا الجديدة",
  Philippines: "فيلبيني",
  Pakistan: "باكستان",
  Poland: "بولندا",
  "Saint Pierre and Miquelon": "سانت بيير وميكلون",
  "Pitcairn Islands": "جزر بيتكيرن",
  "Puerto Rico": "بورتوريكو",
  Palestine: "فلسطين",
  Portugal: "البرتغال",
  Palau: "بالاو",
  Paraguay: "باراجواي",
  Qatar: "دولة قطر",
  Réunion: "رونيون",
  Romania: "رومانيا",
  Serbia: "صربيا",
  Russia: "روسيا",
  Rwanda: "رواندا",
  "Saudi Arabia": "المملكة العربية السعودية",
  "Solomon Islands": "جزر السولومون",
  Seychelles: "سيشيل",
  Sudan: "السودان",
  Sweden: "السويد",
  Singapore: "سنغافورة",
  "Saint Helena": "سانت هيلانة",
  Slovenia: "سلوفينيا",
  "Svalbard and Jan Mayen": "سفالبارد وجان ماين",
  Slovakia: "سلوفاكيا",
  "Sierra Leone": "سيرا ليون",
  "San Marino": "سان مارينو",
  Senegal: "السنغال",
  Somalia: "الصومال",
  Suriname: "سورينام",
  "South Sudan": "جنوب السودان",
  "São Tomé and Príncipe": "ساو تومي وبرينسيبي",
  "El Salvador": "السلفادور",
  "Sint Maarten": "سينت مارتن",
  Syria: "سوريا",
  Swaziland: "سوازيلاند",
  "Turks and Caicos Islands": "جزر تركس وكايكوس",
  Chad: "تشاد",
  "French Southern Territories": "المناطق الجنوبية لفرنسا",
  Togo: "توجو",
  Thailand: "تايلاند",
  Tajikistan: "طاجيكستان",
  Tokelau: "توكيلاو",
  "East Timor": "تيمور الشرقية",
  Turkmenistan: "تركمانستان",
  Tunisia: "تونس",
  Tonga: "تونغا",
  Turkey: "تركيا",
  "Trinidad and Tobago": "ترينداد وتوباغو",
  Tuvalu: "توفالو",
  Taiwan: "تايوان",
  Tanzania: "تنزانيا",
  Ukraine: "أوكرانيا",
  Uganda: "أوغندا",
  "U.S. Minor Outlying Islands": "جزر الولايات المتحدة النائية الصغيرة",
  "United States": "الولايات المتحدة",
  Uruguay: "أوروغواي",
  Uzbekistan: "أوزبكستان",
  "Vatican City": "مدينة الفاتيكان",
  "Saint Vincent and the Grenadines": "سانت فنسنت وجزر غرينادين",
  Venezuela: "فنزويلا",
  "British Virgin Islands": "جزر فيرجن البريطانية",
  "U.S. Virgin Islands": "جزر فيرجن الأمريكية",
  Vietnam: "فيتنام",
  Vanuatu: "فانواتو",
  "Wallis and Futuna": "واليس وفوتونا",
  Samoa: "ساموا",
  Kosovo: "كوسوفو",
  Yemen: "اليمن",
  Mayotte: "مايوت",
  "South Africa": "جنوب أفريقيا",
  Zambia: "زامبيا",
  Zimbabwe: "زيمبابوي",
};

export const service_type_enums = [
  { value: null, text: "please-select-option" },
  {
    value: "Normal",
    text: "normal",
  },
  {
    value: "Product",
    text: "product",
  },
  {
    value: "Kpi",
    text: "kpi-deduction",
  },
  {
    value: "Jeddah Morabata",
    text: "jeddah-morabata",
  },
  {
    value: "Madinah Morabata",
    text: "madinah-morabata",
  },
  {
    value: "Hajj",
    text: "hajj-service-type",
  },
];

export const pricing_method_enums = [
  { value: null, text: "please-select-option" },
  {
    value: "Monthly",
    text: "monthly",
  },
  {
    value: "Daily",
    text: "daily",
  },
  {
    value: "Trip",
    text: "trip-enum",
  },
  {
    value: "Seat",
    text: "seat",
  },
];

export const paymentMethodOptions = [
  { value: null, text: "please-select-option" },
  {
    value: "card",
    text: "card",
  },
  {
    value: "cash",
    text: "cash",
  },
  {
    value: "bank transfer",
    text: "bank-transfer",
  },
];


export const weekdays = [
  { label: "Sun", value: "Sunday", selected: true },
  { label: "Mon", value: "Monday", selected: true },
  { label: "Tue", value: "Tuesday", selected: true },
  { label: "Wed", value: "Wednesday", selected: true },
  { label: "Thu", value: "Thursday", selected: true },
  { label: "Fri", value: "Friday", selected: true },
  { label: "Sat", value: "Saturday", selected: true },
];